<script>


export default {
  components: {

  },
  data() {
    return {
      earnings: [
        {
          name: "Este mês",
          amount: "R$ 245.443,35",
          revenue: "70",
          time: "dos orçamentos",
          month: "Mês anterior",
          previousamount: "R$ 228.100,04",
          series: [
            {
              name: "series1",
              data: [31, 40, 36, 51, 49, 72, 69, 56, 68, 82, 68, 76],
            },
          ],
        },
      ],
      chartOptions: {
        chart: {
          height: 320,
          type: "line",
          toolbar: "false",
          dropShadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 7,
            blur: 8,
            opacity: 0.2,
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#556ee6"],
        stroke: {
          curve: "smooth",
          width: 3,
        },
      },
    };
  },
  methods: {
    monthlyEarning(event) {
      switch (event.target.value) {
        case "marco":
          this.earnings = [
            {
              name: "Março",
              amount: "R$ 240.530,35",
              revenue: "0.4",
              time: "do período anterior",
              month: "Último mês",
              previousamount: "R$ 220.810,04",
              series: [
                {
                  name: "series1",
                  data: [31, 40, 36, 51, 49, 72, 69, 56, 68, 82, 68, 76],
                },
              ],
            },
          ];
          break;
        case "fevereiro":
          this.earnings = [
            {
              name: "Fevereiro",
              amount: "R$ 288.700,35",
              revenue: "0.4",
              time: "do período anterior",
              month: "Último mês",
              previousamount: "R$ 684.100,04",
              series: [
                {
                  name: "series1",
                  data: [28, 30, 48, 50, 47, 40, 35, 48, 56, 42, 65, 41],
                },
              ],
            },
          ];
          break;

        case "janeiro":
          this.earnings = [
            {
              name: "Janeiro",
              amount: "R$ 210.000,35",
              revenue: "0.4",
              time: "do período anterior",
              month: "Último mês",
              previousamount: "R$ 674.870,04",
              series: [
                {
                  name: "series1",
                  data: [28, 48, 39, 47, 58, 46, 38, 47, 30, 40, 70, 42],
                },
              ],
            },
          ];
          break;

        case "dezembro":
          this.earnings = [
            {
              name: "Dezembro",
              amount: "R$ 245.530,35",
              revenue: "0.4",
              time: "do período anterior",
              month: "Último mês",
              previousamount: "R$ 228.100,04",
              series: [
                {
                  name: "series1",
                  data: [31, 40, 36, 51, 49, 72, 69, 56, 68, 82, 68, 76],
                },
              ],
            },
          ];
          break;

        default:
          this.earnings = [
            {
              name: "This month",
              amount: "$2453.35",
              revenue: "0.4",
              time: "From previous period",
              month: "Last month",
              previousamount: "$2281.04",
              series: [
                {
                  name: "series1",
                  data: [31, 40, 36, 51, 49, 72, 69, 56, 68, 82, 68, 76],
                },
              ],
            },
          ];
      }
    },
  },
};
</script>

<template>
    <div class="card">
      <div class="card-body">
        <div class="clearfix">
          <div class="float-end">
            <div class="input-group input-group-sm">
              <select
                id="selectPerFatQuinz"
                class="form-select form-select-sm"
                @change="monthlyEarning($event)"
              >
                <option value="marco" selected>Mar</option>
                <option value="fevereiro">Fev</option>
                <option value="janeiro">Jan</option>
                <option value="dezembro">Dez</option>
              </select>
              <label class="input-group-text" for="selectPerFatQuinz">Mês</label>
            </div>
          </div>
          <h4 class="card-title mb-4">Faturamento Quinzena</h4>
        </div>

        <div class="row" v-for="(data, index) of earnings" :key="index">
          <div class="col-lg-4">
            <div class="text-muted">
              <div class="mb-4">
                <p>{{ data.name }}</p>
                <h4>{{ data.amount }}</h4>
                <div>
                  <span class="badge badge-soft-success font-size-12 me-1"
                    >+ {{ data.revenue }}%</span
                  >
                  {{ data.time }}
                </div>
              </div>

              <div>
                <router-link to="/pedidos/list" class="btn btn-primary btn-sm">
                  Mais detalhes
                  <i class="mdi mdi-chevron-right ml-1"></i>
                </router-link>
              </div>

              <div class="mt-4">
                <p class="mb-2">{{ data.month }}</p>
                <h5>{{ data.previousamount }}</h5>
              </div>
            </div>
          </div>
          <div class="col-lg-8">
            <div id="line-chart"></div>
            <apexchart
              class="apex-charts"
              dir="ltr"
              height="300"
              :series="data.series"
              :options="chartOptions"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>
</template>
